<div class="tw-mt-6 lg:tw-mt-12 tw-pb-6 lg:tw-pb-4">
  <div class="tw-flex tw-items-center tw-gap-4 tw-pb-4">
    <h1 class="tw-text-gray-700 tw-text-lg tw-font-bold lg:tw-text-3xl tw-font-inter">Brand & Identity</h1>
    @if (isSaving() || showSavedIndicator()) {
    <app-saving-indicator [state]="isSaving() ? 'saving' : 'saved'" (savedDone)="onSavedIndicatorDone()"></app-saving-indicator>
    }
  </div>
  <div
    class="tw-w-full tw-p-4 tw-bg-white tw-rounded-xl tw-border-gray-200 tw-border tw-inline-flex tw-flex-col tw-justify-start tw-items-start tw-gap-6 tw-overflow-hidden tw-mb-6"
  >
    <app-banner-upload-field
      [organizationId]="eventData()?.workspace_id || organizationId()"
      [eventId]="eventData()?.id || eventId()"
      [originalImageUrl]="eventData()?.original_image ?? null"
      label="Event Banner"
      hint="Attach photos in PNG, JPG, JPEG, WEBP, BMP. (Aspect ratio: 12:5)"
      [showIcon]="true"
      [control]="eventIdentityForm().get('cover_page')"
      [isLoading]="isLoading()"
      (valueChanged)="onBannerChanged($event)"
    ></app-banner-upload-field>

    @if (isLoading()) {
    <ngx-skeleton-loader
      count="1"
      [theme]="{ width: '100%', height: '36px', 'border-radius': '8px', backgroundColor: '#e5e7eb', color: '#d1d5db' }"
      animation="pulse"
      class="tw-w-full"
    ></ngx-skeleton-loader>
    <ngx-skeleton-loader
      count="1"
      [theme]="{ width: '100%', height: '36px', 'border-radius': '8px', backgroundColor: '#e5e7eb', color: '#d1d5db' }"
      animation="pulse"
      class="tw-w-full"
    ></ngx-skeleton-loader>
    } @else {
    <basic-input
      [control]="eventIdentityForm().get('name')"
      [placeholder]="'Event Name'"
      [id]="'event-name'"
      [mode]="BasicInputMode.INLINE"
      [allowClearButton]="false"
      [required]="true"
      [autofocus]="!eventIdentityForm().get('name').value.trim() ? true : false"
      (onFocusInput)="onNameFocus()"
      (onValueChange)="onEventNameChanged($event)"
      (onBlurValueChange)="onNameBlur()"
      (onKeydown)="handleTextFieldKeydown($event)"
      class="tw-w-full"
    ></basic-input>

    <div class="tw-flex tw-flex-col lg:tw-flex-row tw-gap-4 tw-w-full">
      <div class="tw-relative tw-w-full" [attr.title]="slugLocked() ? slugLockedTitle : null">
        <basic-input
          [label]="'Event Short name'"
          [control]="eventIdentityForm().get('slug')"
          [placeholder]="'Event Short name'"
          [id]="'event-slug'"
          [allowClearButton]="false"
          [class.tw-opacity-60]="slugLocked()"
          (onFocusInput)="onSlugFocus()"
          (onBlurValueChange)="onSlugBlur()"
          (onKeydown)="handleTextFieldKeydown($event)"
          class="tw-w-full"
        ></basic-input>
      </div>

      <select-input
        class="tw-w-full"
        [control]="eventIdentityForm().get('industry_sector_ids')"
        placeholder="Industry focus"
        label="Industry focus"
        (blurEvent)="onIndustrySectorsBlur()"
        key="name"
        [valueName]="'id'"
        [values]="industrySectors()"
        [minSelections]="1"
        [maxSelections]="3"
        [isDropdown]="true"
        [basicSelect]="true"
        [enableSearch]="true"
        [isCountryField]="false"
        [isSingleSelect]="false"
        [clear]="true"
        [id]="'industry_focus_id'"
        (valueChanged)="onIndustrySectorsChanged($event)"
        (maxSelectionsExceeded)="onIndustrySectorsMaxExceeded()"
      ></select-input>
    </div>
    }
  </div>
  <div class="tw-w-full tw-p-4 tw-bg-white tw-rounded-xl tw-border-gray-200 tw-border tw-inline-flex tw-flex-col tw-justify-start tw-items-start tw-gap-6 tw-overflow-hidden">
    <app-social-media-links [event]="eventData()" [isLoadingEvent]="isLoading()"></app-social-media-links>
  </div>
</div>
